import { Collection } from 'generated/graphql/types';

export interface CollectionCardDescriptionProps {
  title: Collection['title'];
}

export const CollectionCardDescription = ({ title }: CollectionCardDescriptionProps) => (
  <p className="font-normal text-opacity-75 text-h-16">{title}</p>
);
